import React from "react";
import { postRequest } from "./QuoteApiService";

export const getQuotesSearchCount = (rec, existingParams) => {
  return new Promise((resolve, reject) => {
    try {
      // do an SDK, DB call or API endpoint axios call here and return the promise.
      postRequest(`getQuotesSearchCount?${existingParams.toString()}`, rec)
      .then((res) => {
        console.log("getQuotesSearchCount > axios res=", res);
        //const persons = res.data;
        resolve(res.data);
      })
      .catch((err) => {
        console.log("getQuotesSearchCount > axios err=", err);
        reject("Error in getQuotesSearchCount axios!");
      });
    } catch (error) {
      console.error("in services > getQuotesSearchCount, Err===", error);
      //reject(SYSTEM_ERROR);
    }
  });
  
}